export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ19.56f90dd2.mp3";